module.exports = __webpack_public_path__ + "Roboto-Medium.88e897b6e48f9b57cbed.svg";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/fonts/Roboto-Medium.svg
// module id = ../../../../../src/assets/fonts/Roboto-Medium.svg
// module chunks = styles